import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  FormControl, Select, MenuItem, IconButton, Tooltip, TextField,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles(() => ({
  root: {
    padding: '12px 16px 8px 16px',
    background: '#f7fafd',
    borderBottom: '1px solid #e0e0e0',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  select: {
    flex: 1,
    minWidth: 0,
    '& .MuiOutlinedInput-input': {
      padding: '8px 8px',
      fontSize: 13,
    },
  },
  iconBtn: {
    border: '1px solid #d0d0d0',
    borderRadius: 6,
    padding: 6,
    background: '#fff',
    '&:hover': { background: '#f0f0f0' },
  },
  nameField: {
    marginTop: 6,
    '& .MuiOutlinedInput-input': {
      padding: '6px 8px',
      fontSize: 13,
    },
  },
}));

const TakeoffSelector = ({
  takeoffs = [],
  activeTakeoffId,
  activeTakeoffName = '',
  onSwitchTakeoff,
  onNewTakeoff,
  onDeleteTakeoff,
  onRenameTakeoff,
  disabled,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <FormControl variant="outlined" size="small" className={classes.select}>
          <Select
            value={activeTakeoffId || ''}
            onChange={(e) => onSwitchTakeoff(e.target.value)}
            displayEmpty
            disabled={disabled}
          >
            {!activeTakeoffId && (
              <MenuItem value="" disabled>
                <em>{takeoffs.length ? 'Select a takeoff' : 'No takeoffs yet'}</em>
              </MenuItem>
            )}
            {takeoffs.map((t) => (
              <MenuItem key={t._id} value={t._id}>
                {t.name || 'Untitled'} ({t.areaCount} areas)
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Tooltip title="New takeoff">
          <span>
            <IconButton
              size="small"
              onClick={onNewTakeoff}
              className={classes.iconBtn}
              disabled={disabled}
            >
              <AddIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
        {activeTakeoffId && (
          <Tooltip title="Delete takeoff">
            <span>
              <IconButton
                size="small"
                onClick={() => {
                  if (window.confirm(`Delete "${activeTakeoffName || 'this takeoff'}"? This cannot be undone.`)) {
                    onDeleteTakeoff(activeTakeoffId);
                  }
                }}
                className={classes.iconBtn}
                disabled={disabled}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </div>
      {(activeTakeoffId || activeTakeoffName) && (
        <TextField
          className={classes.nameField}
          fullWidth
          variant="outlined"
          size="small"
          value={activeTakeoffName}
          onChange={(e) => onRenameTakeoff(e.target.value)}
          placeholder="Takeoff name"
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default TakeoffSelector;
